import {DevelopmentPickerServerQuery} from '@github-ui/server-persisted-queries'
import type {DevelopmentPickerServerQueryQuery} from '@github-ui/server-persisted-queries/types/DevelopmentPickerServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

type DevelopmentPickerQueryRepository = Extract<
  DevelopmentPickerServerQueryQuery['node'],
  {readonly repository: unknown}
>['repository']

export type DevelopmentPickerRepository = Pick<DevelopmentPickerQueryRepository, 'name' | 'nameWithOwner'> & {
  readonly owner: Pick<DevelopmentPickerQueryRepository['owner'], 'login'>
}

export function developmentPickerQueryKey(owner: string, repo: string, number: number) {
  return ['issue-viewer', 'development-picker', {owner, repo, number}] as const
}

export async function fetchDevelopmentPicker(
  owner: string,
  repo: string,
  number: number,
  signal?: AbortSignal,
): Promise<DevelopmentPickerRepository | null> {
  const query = new URLSearchParams({queryId: DevelopmentPickerServerQuery})
  const response = await reactFetchJSON(
    `/${owner}/${repo}/issues/${number}/development_picker.json?${query.toString()}`,
    {
      signal,
    },
  )

  if (!response.ok) throw new Error(`Development picker fetch failed (${response.status})`)

  const json = (await response.json()) as {data?: DevelopmentPickerServerQueryQuery; errors?: unknown[]}
  if (json.errors?.length || !json.data) throw new Error('Development picker query returned errors')

  return json.data.node && 'repository' in json.data.node ? json.data.node.repository : null
}
